module.exports = __webpack_public_path__ + "img/nomail.e19f5270.png";